<template>
  <div>
    <v-tour id="tour" name="tour" :steps="tourSteps" :callbacks="tourCallbacks" :options="tourOptions"></v-tour>
  </div>
</template>

<script>
import tourStepsJSON from '@/assets/data/toursteps.json'

export default {
  name: 'tour',
  props: ['showTour'],
  data () {
    return {
      tourCallbacks: {
        onStop: this.deactivateTour
      },
      tourOptions: {
        labels: {
          buttonSkip: 'Skip tour',
          buttonPrevious: 'Prev',
          buttonNext: 'Next',
          buttonStop: 'Finish'
        }
      }
    }
  },
  computed: {
    tourSteps () {
      return tourStepsJSON
    }
  },
  methods: {
    // set showTour var in parent when tour is stopped via "skip tour" btn
    deactivateTour () {
      this.$emit('toggleTour', false)
    },
    tourActivation () {
      if (this.showTour === true) {
        this.$tours['tour'].start()
      } else {
        this.$tours['tour'].stop()
      }
    }
  },
  watch: {
    showTour: 'tourActivation'
  },
  mounted: function () {
    this.tourActivation()
  }
}
</script>

<style scoped>
  #tour >>> .v-step[data-v-aa0cbe42]{
    z-index: 7; /* let users open dropdowns on top of tour steps to try them out - v-menu__content has z-index 8 */
    background:#1E88E5;
    color: #fff;
    -webkit-filter: drop-shadow(0 0 4px rgba(255, 255, 255, .5));
    filter: drop-shadow(0 0 4px rgba(255, 255, 255, .5));
  }
   #tour >>> .v-step .v-step__arrow[data-v-aa0cbe42]{
    border-color: #1E88E5
  }
  #tour >>> .v-step .v-step__arrow--dark[data-v-aa0cbe42]{
    border-color: #1E88E5
  }
  #tour >>> .v-step[x-placement^=top] .v-step__arrow[data-v-aa0cbe42]{
    border-left-color: transparent;
    border-right-color: transparent;
    border-bottom-color: transparent;
  }
  #tour >>> .v-step[x-placement^=bottom] .v-step__arrow[data-v-aa0cbe42]{
    border-left-color: transparent;
    border-right-color: transparent;
    border-top-color: transparent;
  }
  #tour >>> .v-step[x-placement^=right] .v-step__arrow[data-v-aa0cbe42]{
    border-left-color: transparent;
    border-top-color: transparent;
    border-bottom-color: transparent;
  }
  #tour >>> .v-step[x-placement^=left] .v-step__arrow[data-v-aa0cbe42]{
    border-top-color: transparent;
    border-right-color: transparent;
    border-bottom-color: transparent;
  }
  #tour >>> .v-step__header[data-v-aa0cbe42]{
    background-color: #1E88E5;
  }
  #tour >>> .v-step__button[data-v-aa0cbe42]{
    /*font-size: .9rem;*/
    background: transparent;
    border: .05rem solid #fff;
    color: #fff;
  }
  #tour >>> .v-step__button[data-v-aa0cbe42]:hover{
    background-color: hsla(0,0%,100%,.95);
    color: #1E88E5
  }
</style>



// WEBPACK FOOTER //
// src/components/Tour.vue